<div class="c-title--subsection text-uppercase">DEFAULT FILTERS</div>
<label for="styleTemplate">Public and Logged in view</label>
<div class="row row--builder default-filters">
    <div class="col col-sm-4 default-filters--padding">
        <ccl-multi-select-dropdown
            [placeholder]="'Session Track:'"
            [data]="sharedService.tracks"
            [(ngModel)]="sessionDataConfig.defaultFilters.track"
            [settings]="tracksDropdownSettings"
        ></ccl-multi-select-dropdown>
    </div>
    <div class="col col-sm-4 default-filters--padding">
        <ccl-multi-select-dropdown
            [placeholder]="'Session Type:'"
            [data]="sharedService.types"
            [(ngModel)]="sessionDataConfig.defaultFilters.type"
            [settings]="typesDropdownSettings"
        ></ccl-multi-select-dropdown>
    </div>
    <div class="col col-sm-4 default-filters--padding">
        <ccl-multi-select-dropdown
            [placeholder]="'Session Tag:'"
            [data]="sharedService.tags"
            [(ngModel)]="sessionDataConfig.defaultFilters.tags"
            [settings]="tagDropdownSettings"
        ></ccl-multi-select-dropdown>
        <span class="c-form-group__hint">&nbsp;</span>
    </div>
</div>
<label for="styleTemplate">Public view</label>
<div class="row row--builder default-filters">
    <div class="col col-sm-4 default-filters--padding">
        <ccl-multi-select-dropdown
            [placeholder]="'Session Status:'"
            [data]="sessionStatus"
            [(ngModel)]="sessionDataConfig.defaultFilters.status"
            [settings]="sessionFilterSettings"
        ></ccl-multi-select-dropdown>
        <span class="c-form-group__hint">&nbsp;</span>
    </div>
    <div class="col col-sm-4 default-filters--padding">
        <ccl-multi-select-dropdown
            [placeholder]="'Attendee Type:'"
            [data]="sharedService.attendeeTypes"
            [(ngModel)]="sessionDataConfig.defaultFilters.attendeeType"
            [settings]="attendeeTypesDropdownSettings"
        ></ccl-multi-select-dropdown>
        <span class="c-form-group__hint">&nbsp;</span>
    </div>
</div>

<div class="row row--builder default-filters">
    <div class="col-sm-6 data-filter-toggle">Show full/past Filter</div>
    <div class="col col-sm-6">
            <ccl-toggle-button
                [title]="sessionDataConfig['showHidePastFilter'] ? 'Enabled' : 'Disabled'"
                [isChecked]="sessionDataConfig['showHidePastFilter']"
                (isCheckedChange)="toggleFilterButton($event)"
            >{{ sessionDataConfig['showHidePastFilter'] ? "Enabled" : "Disabled" }}</ccl-toggle-button>
    </div>
</div>
<br>

<div class="row row--builder default-filters">
    <ccl-checkbox
        buttonStyle="c-checkbox"
        (clickEvent)="
            sessionDataConfig.defaultFilters.hideFullSessions = !sessionDataConfig.defaultFilters.hideFullSessions
        "
        [id]="'hideFullSessions'"
        [value]="sessionDataConfig.defaultFilters.hideFullSessions"
        >Hide full sessions</ccl-checkbox
    >
</div>
<br>

<div class="row row--builder default-filters">
    <ccl-checkbox
        buttonStyle="c-checkbox"
        (clickEvent)="
            sessionDataConfig.defaultFilters.hidePastSessions = !sessionDataConfig.defaultFilters.hidePastSessions
        "
        [id]="'hidePastSessions'"
        [value]="sessionDataConfig.defaultFilters.hidePastSessions"
        >Hide past sessions</ccl-checkbox
    >
</div>

<div *ngIf="false" class="c-title--subsection text-uppercase mar-20">DISPLAY STYLE</div>
<div *ngIf="false" class="row row--builder">
    <div class="col col-sm-6 default-filters--padding">
        <label for="styleTemplate">Display Style Template</label>
        <ccl-simple-select formId="styleTemplate"
            [listOfItems]="groupTemplate.group"
            (valueChange)="valueChangeGroup($event)"
            [value]="sessionDataConfig.group"
            [bindLabel]="'label'"
            [bindValue]="'code'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
</div>

<div class="c-title--subsection text-uppercase mar-20 mar-top-50">GROUPING</div>

<div class="row row--builder">
    <div class="col col-sm-4 default-filters--padding">
        <label for="topGroup">Top Level Grouping</label>
        <ccl-simple-select formId="topGroup"
            [listOfItems]="firstLevelSort"
            (valueChange)="valueChangeEvent($event, 'topLevel')"
            [value]="sessionDataConfig.topLevel.sortingBy"
            [bindLabel]="'label'"
            [bindValue]="'code'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
    <div
        class="col col-sm-3"
        *ngIf="sessionDataConfig.topLevel.sortingBy == 'date' || sessionDataConfig.topLevel.sortingBy == 'dateTime'"
    >
        <label for="topDF">Date Format</label>
        <ccl-simple-select formId="topDF"
            [listOfItems]="sharedService.dateFormats"
            (valueChange)="sessionDataConfig.dateTimeFormats.dateFormat = $event.value"
            [value]="sessionDataConfig.dateTimeFormats.dateFormat"
            [bindLabel]="'label'"
            [bindValue]="'format'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
    <div class="col col-sm-2" *ngIf="sessionDataConfig.topLevel.sortingBy == 'dateTime'">
        <label for="topTF">Time Format</label>
        <ccl-simple-select formId="topTF"
            [listOfItems]="sharedService.timeFormats"
            (valueChange)="sessionDataConfig.dateTimeFormats.timeFormat = $event.value"
            [value]="sessionDataConfig.dateTimeFormats.timeFormat"
            [bindLabel]="'label'"
            [bindValue]="'format'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
</div>

<div class="row row--builder mar-20" *ngIf="sessionDataConfig.secondLevel.active && topLevelIndex > -1">
    <div class="col col-sm-4 default-filters--padding">
        <label for="secondGroup">Second Level Grouping</label>
        <ccl-simple-select formId="secondGroup"
            [listOfItems]="secondLevelSort"
            (valueChange)="valueChangeEvent($event, 'secondLevel')"
            [value]="sessionDataConfig.secondLevel.sortingBy"
            [bindLabel]="'label'"
            [bindValue]="'code'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
    <div
        class="col col-sm-3"
        *ngIf="
            sessionDataConfig.secondLevel.sortingBy == 'date' || sessionDataConfig.secondLevel.sortingBy == 'dateTime'
        "
    >
        <label for="secondDF">Date Format</label>
        <ccl-simple-select formId="secondDF"
            [listOfItems]="sharedService.dateFormats"
            (valueChange)="sessionDataConfig.dateTimeFormats.dateFormat = $event.value"
            [value]="sessionDataConfig.dateTimeFormats.dateFormat"
            [bindLabel]="'label'"
            [bindValue]="'format'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
    <div class="col col-sm-2" *ngIf="sessionDataConfig.secondLevel.sortingBy == 'dateTime'">
        <label for="secondTF">Time Format</label>
        <ccl-simple-select formId="secondTF"
            [listOfItems]="sharedService.timeFormats"
            (valueChange)="sessionDataConfig.dateTimeFormats.timeFormat = $event.value"
            [value]="sessionDataConfig.dateTimeFormats.timeFormat"
            [bindLabel]="'label'"
            [bindValue]="'format'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
    <div class="col col-sm-1 close-icon">
        <span (cclClick)="deleteLevel('second')"><i class="fa fa-times" aria-hidden="true"></i></span>
    </div>
</div>

<div
    class="row row--builder mar-20"
    *ngIf="sessionDataConfig.thirdLevel.active && topLevelIndex > -1 && secondLevelIndex > -1"
>
    <div class="col col-sm-4 default-filters--padding">
        <label for="thirdGroup">Third Level Grouping</label>
        <ccl-simple-select formId="thirdGroup"
            [listOfItems]="thirdLevelSort"
            (valueChange)="valueChangeEvent($event, 'thirdLevel')"
            [value]="sessionDataConfig.thirdLevel.sortingBy"
            [bindLabel]="'label'"
            [bindValue]="'code'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
    <div
        class="col col-sm-3"
        *ngIf="sessionDataConfig.thirdLevel.sortingBy == 'date' || sessionDataConfig.thirdLevel.sortingBy == 'dateTime'"
    >
        <label for="thirdDF">Date Format</label>
        <ccl-simple-select formId="thirdDF"
            [listOfItems]="sharedService.dateFormats"
            (valueChange)="sessionDataConfig.dateTimeFormats.dateFormat = $event.value"
            [value]="sessionDataConfig.dateTimeFormats.dateFormat"
            [bindLabel]="'label'"
            [bindValue]="'format'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
    <div class="col col-sm-2" *ngIf="sessionDataConfig.thirdLevel.sortingBy == 'dateTime'">
        <label for="thirdTF">Time Format</label>
        <ccl-simple-select formId="thirdTF"
            [listOfItems]="sharedService.timeFormats"
            (valueChange)="sessionDataConfig.dateTimeFormats.timeFormat = $event.value"
            [value]="sessionDataConfig.dateTimeFormats.timeFormat"
            [bindLabel]="'label'"
            [bindValue]="'format'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
    <div class="col col-sm-1 close-icon">
        <span (cclClick)="deleteLevel('third')"><i class="fa fa-times" aria-hidden="true"></i></span>
    </div>
</div>

<div
    class="row row--builder mar-20 mar-bottom-50"
    [hidden]="sessionDataConfig.thirdLevel.active || remainingLevel <= 0"
>
    <div class="c-form-group">
        <div (cclClick)="goToCreatePage(remainingLevel)" class="c-add-element">
            <div class="c-add-element__label" id="addAnotherGroup">ADD ANOTHER GROUPING</div>
            <div class="c-btn-add--primary--small" aria-labelledby="addAnotherGroup"></div>
        </div>
        <div class="c-form-group__hint">
            {{ remainingLevel }} <span *ngIf="remainingLevel > 1; else level">Levels</span>
            <ng-template #level>Level</ng-template> Available
        </div>
    </div>
</div>

<div class="c-title--subsection text-uppercase mar-20 mar-top-50">SORTING</div>

<div class="row row--builder">
    <div class="col col-sm-4 default-filters--padding">
        <label for="topGroup">Primary Sorting</label>
        <ccl-simple-select formId="sort"
            [listOfItems]="primarySortList"
            (valueChange)="valueonSortChange($event)"
            [value]="sessionDataConfig.sort.primarySort"
            [bindLabel]="'label'"
            [bindValue]="'code'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
    <div
        *ngIf="sessionDataConfig.sort.primarySort"
        class="col col-sm-3"
    >
        <label for="topDF">Sort Order</label>
        <ccl-simple-select formId="sortOrder"
            [listOfItems]="sortOrder"
            (valueChange)="sessionDataConfig.sort.primarySortOrder = $event.value"
            [value]="sessionDataConfig.sort.primarySortOrder"
            [bindLabel]="'label'"
            [bindValue]="'code'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
</div>

<hr />
<div class="row row--builder">
    <div class="col-sm-10 c-title--subsection text-uppercase default-filters--padding">
        SECTION PREVIEW
    </div>
    <div class="col-sm-2">
        <ccl-basic-button (clickEvent)="openConfigDrawer('grouping-display-config')" buttonStyle="c-btn--secondary"
            >Grouping Style
        </ccl-basic-button>
    </div>
</div>
<span *ngIf="defaultData"
    ><strong>Note : You don't have any sessions yet, so this preview is based on dummy data.</strong></span
>
<img alt="Loading..." *ngIf="sharedService.loadingList" src="assets/images/loading.gif" />
<div class="pointerEvent">
    <div #generalList class="mtop50"></div>
</div>
